export function compareComma(af: number, bf: number, decimalPlaces: number): number {
  const p = 10 ** decimalPlaces;
  const ret = Math.floor(p * af + 0.5) - Math.floor(p * bf + 0.5);
  return ret;
}

export function gtc(af: number, bf: number, decimalPlaces: number = 3): boolean {
  return compareComma(af, bf, decimalPlaces) > 0;
}

export function gec(af: number, bf: number, decimalPlaces: number = 3): boolean {
  return compareComma(af, bf, decimalPlaces) >= 0;
}

export function ltc(af: number, bf: number, decimalPlaces: number = 3): boolean {
  return compareComma(af, bf, decimalPlaces) < 0;
}

export function lec(af: number, bf: number, decimalPlaces: number = 3): boolean {
  return compareComma(af, bf, decimalPlaces) <= 0;
}

export function eqc(af: number, bf: number, decimalPlaces: number = 3): boolean {
  return compareComma(af, bf, decimalPlaces) === 0;
}